import { HoverBubbles } from "@/components/site/HoverBubbles";

/** Conservé pour compat — délègue au composant générique. */
export const FooterBubbles = () => <HoverBubbles />;
